<template>
  <div v-if="hasChanges">
    <h6 class="mt-2 mb-1 text-primary">
      <feather-icon
icon="GitCommitIcon"
size="16"
class="mr-1"
/>
      Proposed Changes
    </h6>
    <b-table-simple
bordered
small
responsive
>
      <b-thead>
        <b-tr>
          <b-th style="width:25%">
Field
</b-th>
          <b-th style="width:37.5%">
Before
</b-th>
          <b-th
style="width:37.5%"
class="text-success"
>
Requested
</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
          v-for="row in changedRows"
          :key="row.field"
        >
          <b-td><strong>{{ row.label }}</strong></b-td>
          <b-td>{{ row.before || '-' }}</b-td>
          <b-td class="text-success font-weight-bold">
{{ row.after || '-' }}
</b-td>
        </b-tr>
        <!-- Photo row -->
        <b-tr v-if="proposedPhoto">
          <b-td><strong>Photo</strong></b-td>
          <b-td>
            <img
              v-if="currentPhoto"
              :src="currentPhoto"
              alt="Current"
              style="max-height:80px; border-radius:6px; cursor:pointer;"
              @click="$emit('show-photo', currentPhoto)"
            >
            <span v-else>-</span>
          </b-td>
          <b-td>
            <img
              :src="proposedPhoto"
              alt="Proposed"
              style="max-height:80px; border-radius:6px; cursor:pointer; border:2px solid #28a745;"
              @click="$emit('show-photo', proposedPhoto)"
            >
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import {
  BTableSimple, BThead, BTbody, BTr, BTh, BTd,
} from 'bootstrap-vue'

const FIELD_LABELS = {
  asset_ref_id: 'Ref ID',
  asset_local_id: 'Local ID',
  asset_category: 'Asset Group',
  asset_description: 'Description',
  asset_note: 'Note',
  asset_gps: 'GPS',
  asset_date_of_acquistion: 'Date of Acquisition',
  asset_acquistion_value: 'Acquisition Value',
  asset_depreciation_method: 'Depreciation Method',
  asset_residual_value: 'Residual Value',
  asset_market_value: 'Market Value',
  asset_condition: 'Condition',
  asset_status: 'Status',
  asset_address: 'Address',
  asset_responsible: 'Responsible',
  asset_serial_no: 'Serial Number',
  asset_warranty: 'Warranty',
  asset_insurance: 'Insurance',
}

export default {
  components: {
    BTableSimple, BThead, BTbody, BTr, BTh, BTd,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    apiUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    proposedData() {
      if (!this.item.asset_is_updated_data) return {}
      try {
        return JSON.parse(this.item.asset_is_updated_data)
      } catch (e) {
        return {}
      }
    },
    changedRows() {
      const rows = []
      Object.keys(this.proposedData).forEach(field => {
        const before = String(this.item[field] ?? '')
        const after = String(this.proposedData[field] ?? '')
        if (before !== after) {
          rows.push({
            field,
            label: FIELD_LABELS[field] || field,
            before,
            after,
          })
        }
      })
      return rows
    },
    proposedPhoto() {
      if (!this.item.asset_is_updated_photo) return ''
      return `${this.apiUrl}upload/${this.item.asset_is_updated_photo}`
    },
    currentPhoto() {
      if (!this.item.asset_photo) return ''
      return `${this.apiUrl}upload/${this.item.asset_photo}`
    },
    hasChanges() {
      return this.changedRows.length > 0 || !!this.proposedPhoto
    },
  },
}
</script>
